module.exports = __webpack_public_path__ + "static/media/manu-14.3ed0ba78.png";